export default __webpack_public_path__ + "static/media/no-image.b21add8f.png";